import {createReducer, on} from '@ngrx/store';
import {ContextData, MultipleRegistrations, ProductQuery} from './context-data';
import * as contextAction from './context-data.actions';

export interface ContextDataState {
  context: ContextData | undefined;
}

export const initialState: ContextDataState = {
  context: undefined,
};

export const reducer = createReducer(
  initialState,
  on(contextAction.loadContextDataSuccess, (state, {context}) => ({
    ...state,
    context: context,
  })),
  on(
    contextAction.loadContextData,
    contextAction.loadContextDataFailure,
    state => state,
  ),
  on(contextAction.updateContextData, (state, {context}) => ({
    ...state,
    context: {
      ...state.context!,
      ...context,
    },
  })),
);

export const contextData = (state: ContextDataState): ContextData | undefined =>
  state.context;
export const multipleRegistrations = (
  state: ContextDataState,
): MultipleRegistrations | undefined => state.context?.multipleRegistrations;

export const eventCost = (
  state: ContextDataState,
): number | null | undefined => {
  const signup = state.context?.signups[0];
  return signup?.requestDetails.eventCost;
};

export const productQuery = (
  state: ContextDataState,
): ProductQuery | undefined => {
  if (!state.context) {
    return undefined;
  }
  return {
    enabledSalesChannels: state.context.enabledSalesChannels,
    registrant: state.context.registrant,
    signupType: state.context.analyticsPageAttributes.surveyType,
    signups: state.context.signups,
  };
};

export const contextOrganizationId = (
  state: ContextDataState,
): number | undefined => state.context?.bossOrganization.id;

export const contextOrganizationName = (
  state: ContextDataState,
): string | undefined => state.context?.bossOrganization.name;

export const customerPaysFee = (state: ContextDataState): boolean => {
  const signup = state.context?.signups[0];
  return signup?.requestDetails.customerPaysFee || false;
};
